import {
  DateRangePickerField,
  Form,
  NumericFormatField,
  SubmitButton,
  TextInputField,
} from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { CostFormSchema } from '../../models';

type FormValues = z.infer<typeof CostFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const CostForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(CostFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <NumericFormatField
        name="code"
        label={t('code')}
        control={control}
        errors={errors}
        disableSeparator
        required
      />
      <TextInputField
        name="name"
        autocompleteKey="cost.name"
        label={t('name')}
        control={control}
        errors={errors}
        required
      />
      <DateRangePickerField
        name="period"
        label={t('start-and-end-year')}
        control={control}
        errors={errors}
        picker="year"
        allowEmpty={[true, true]}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
